import {dataTestId} from '@hconnect/uikit'
import {HPButton, HPButtonProps} from '@hconnect/uikit/src/lib2'
import {ManageSearch} from '@mui/icons-material'
import {useTranslation} from 'react-i18next'

import {useAnalyzeProductionPlan} from '../../../shared/hooks/api/optimizer'

interface AnalyzeProductionPlanButtonProps {
  backgroundMode?: HPButtonProps['backgroundMode']
}

export const AnalyzeProductionPlanButton: React.FC<AnalyzeProductionPlanButtonProps> = ({
  backgroundMode
}) => {
  const {t} = useTranslation()

  const {analyzeProductionPlan, isLoading: shouldDisableAnalyzeButton} = useAnalyzeProductionPlan()

  return (
    <HPButton
      startIcon={<ManageSearch />}
      backgroundMode={backgroundMode}
      color="secondary"
      disabled={shouldDisableAnalyzeButton}
      onClick={analyzeProductionPlan}
      {...dataTestId('analyze_production_plan_button')}
    >
      {t('optimizer.analyzeProductionPlan')}
    </HPButton>
  )
}
